/**
 * Resolves the GraphQL WebSocket URL for subscriptions.
 * Uses REACT_APP_WS_* when set; otherwise derives ws/wss from the HTTP GraphQL URL.
 */
export const resolveGraphqlWsUrl = (explicitWsUrl, httpGraphqlUrl) => {
  const fromEnv = (explicitWsUrl || "").trim();
  if (fromEnv) {
    return fromEnv;
  }
  const httpUrl = (httpGraphqlUrl || "").trim();
  if (!httpUrl) {
    return "";
  }
  return httpUrl.replace(/^https:/i, "wss:").replace(/^http:/i, "ws:");
};
